<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/ata-rangi')">Ata Rangi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/bell-hill-vineyards')">Bell Hill Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/craggy-range')">Craggy Range
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/dog-point-vineyards')">Dog Point Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/millton-vineyards-and-winery')">Millton
                        Vineyards and Winery
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/pyramid-valley-vineyards')">Pyramid Valley
                        Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/new-zealand/rippon-vineyards')">Rippon Vineyards
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/new-zealand/trinity-hill')">Trinity Hill
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/new-zealand')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Trinity Hill</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considerata da alcuni come un nuovo vino sul blocco, la Nuova Zelanda ha in realtà una storia ben radicata
                        vinificazione. Mentre il vino neozelandese fa risalire la sua storia al XIX secolo, il vino moderno
                        l'industria in Nuova Zelanda è iniziata a metà del XX secolo e si è espansa rapidamente all'inizio del XXI
                        secolo, con una media di un massiccio 17% annuo nei primi due decenni. Questa da sola è una buona notizia per
                        investitori di vino di tutto il mondo, ma l'impressionante potenziale (per non parlare del gusto) di Trinity
                        Spiccano i vini di collina.
                    </div>

                    <div class="howto-title2">Una decisione miliardaria...</div>
                    <div class="howto-text">
                        Ancora più impressionante è stata la decisione del 2014 di Charles Banks (famoso per Screaming Eagle) di investire
                        Trinità. Le banche hanno investito denaro per il 70% delle partecipazioni di Trinity, il che significa una crescita presumibilmente lunga
                        per il produttore di Gimblett Gravels e buone notizie per l'industria vinicola neozelandese. Con americano
                        miliardari come Banks investono pesantemente, sicuramente ne seguiranno altri?
                        <br><br>
                        Trinity Hill Burst è arrivato sulla scena enologica del nuovo mondo tra grandi promesse. Fondata da John, Robert e Robyn Wilson, e Trevor e Hanne James, la partnership a tre ha acquistato il loro primo vigneto nel 1993 e ha prodotto i loro primi vini nel 1996. Una nuova cantina è stata costruita nel 1997 e altri 20 ettari di ghiaie sono stati acquistati nel 2000. Rendendosi conto di aver raggiunto l'oro con la loro fusione unica di terroir, conoscenze enologiche e tecniche agricole, il trio di investitori desiderava portare vini eccellenti a un altro livello, ma i vincoli finanziari ha mantenuto una crescita costante piuttosto che esplosiva. L'interesse delle banche non poteva avere un momento migliore per Trinity.
                    </div>

                    <div class="howto-title2">... Oppure no</div>
                    <div class="howto-text">
                        Tuttavia, quando le cose sono troppo belle per essere vere, di solito lo sono, e Banks è stato condannato a quattro
                        anni di reclusione per frode nel 2017. Questo ovviamente è stato un duro colpo per il vigneto e
                        sospendere i piani di espansione. Il lato positivo di questa nuvola era che Trinity era di nuovo
                        gettato sotto i riflettori. Il successivo interesse dopo il processo nella cantina di Hawke's Bay
                        si è rivelato fortuito per Trinity e per i loro vini eccezionali e coerenti. In particolare, l'Omaggio
                        Il Syrah è un vero spicco, uno dei migliori rossi della Nuova Zelanda. I prezzi sono rimasti stabili a circa
                        75 euro a bottiglia, ma con Banks dietro le sbarre, solo il tempo dirà se Trinity potrebbe aver morso
                        via più di quanto possano masticare.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Trinity Hill</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Neuseeland wird von manchen als neuer Wein auf dem Markt angesehen und hat tatsächlich eine tief verwurzelte Geschichte
                        Wein machen. Während der neuseeländische Wein seine Geschichte bis ins 19. Jahrhundert zurückverfolgt, ist der moderne Wein
                        Die Industrie in Neuseeland begann Mitte des 20. Jahrhunderts und expandierte Anfang des 21. Jahrhunderts rasch
                        Jahrhundert, in den ersten zwei Jahrzehnten durchschnittlich satte 17 % pro Jahr. Das allein ist eine gute Nachricht für
                        Weininvestoren auf der ganzen Welt, aber das beeindruckende Potenzial (ganz zu schweigen vom Geschmack) von Trinity
                        Hügelweine stechen hervor.
                    </div>

                    <div class="howto-title2">Eine Milliardärsentscheidung ...</div>
                    <div class="howto-text">
                        Noch beeindruckender war die Entscheidung von Charles Banks (bekannt durch Screaming Eagle) im Jahr 2014, in dieses Unternehmen zu investieren
                        Dreieinigkeit. Banken stellten Bargeld für 70 % der Bestände von Trinity bereit, was auf ein angeblich langes Wachstum hindeutet
                        für den Gimblett Gravels-Produzenten und gute Nachrichten für die neuseeländische Weinindustrie. Mit Amerikaner
                        Wenn Milliardäre wie Banks massiv investieren, würden sicherlich andere folgen?
                        <br><br>
                        Trinity Hill Burst betrat vielversprechend die Weinszene der neuen Welt. Die von John, Robert und Robyn Wilson sowie Trevor und Hanne James gegründete Dreierpartnerschaft kaufte 1993 ihren ersten Weinberg und produzierte 1996 ihre ersten Weine. 1997 wurde ein neues Weingut gebaut, und im Jahr 2000 wurden weitere 20 Hektar Kies gekauft. Als ihnen klar wurde, dass sie mit ihrer einzigartigen Kombination aus Terroir, önologischem Wissen und Anbautechniken auf Gold gestoßen waren, wollte das Investorentrio unbedingt exzellente Weine zu einem anderen bringen Allerdings hielten finanzielle Zwänge das Wachstum eher stabil als explosionsartig. Das Interesse der Banken könnte für Trinity zu keinem besseren Zeitpunkt gekommen sein.
                    </div>

                    <div class="howto-title2">... Oder auch nicht</div>
                    <div class="howto-text">
                        Wenn die Dinge jedoch zu schön sind, um wahr zu sein, sind sie es normalerweise, und Banks wurde zu vier Haftstrafen verurteilt
                        Wegen Betrugs im Jahr 2017 zu einer mehrjährigen Haftstrafe verurteilt. Dies war offensichtlich ein schwerer Schlag für das Weingut und
                        die Expansionspläne auf Eis legen. Der Silberstreif am Horizont dieser Wolke war, dass Trinity wieder da war
                        ins Rampenlicht gerückt. Das darauffolgende Interesse nach dem Prozess im Weingut Hawke’s Bay
                        erwies sich für Trinity und ihre stets hervorragenden Weine als Glücksfall. Insbesondere die Hommage
                        Syrah ist ein echtes Highlight – einer der besten Rotweine Neuseelands. Die Preise sind bei etwa stabil geblieben
                        75 Euro pro Flasche, aber da Banks hinter Gittern sitzt, wird nur die Zeit zeigen, ob Trinity möglicherweise gebissen hat
                        mehr ab, als sie ertragen können.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Trinity Hill</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considérée par certains comme un nouveau vin sur le bloc, la Nouvelle-Zélande a en fait une histoire profondément enracinée dans
                        vinification. Alors que le vin néo-zélandais retrace son histoire au XIXe siècle, le vin moderne
                        l'industrie en Nouvelle-Zélande a commencé au milieu du 20e siècle et s'est rapidement développée au début du 21e
                        siècle, avec une moyenne massive de 17 % par an au cours des deux premières décennies. Cela seul est une bonne nouvelle pour
                        investisseurs en vins du monde entier, mais l'impressionnant potentiel (sans parler du goût) de Trinity
                        Les vins de colline se démarquent.
                    </div>

                    <div class="howto-title2">Une décision de milliardaire...</div>
                    <div class="howto-text">
                        Encore plus impressionnante a été la décision de Charles Banks (du célèbre Screaming Eagle) en 2014 d'investir dans
                        Trinité. Les banques ont versé des liquidités pour 70% des avoirs de Trinity, ce qui signifie une croissance supposée longue
                        pour le producteur de Gimblett Gravels, et une bonne nouvelle pour l'industrie vinicole néo-zélandaise. Avec l'Américain
                        des milliardaires tels que Banks investissent massivement, d'autres suivraient sûrement?
                        <br><br>
                        L'éclatement de Trinity Hill est arrivé sur la nouvelle scène mondiale de la vinification au milieu de grandes promesses. Fondé par John, Robert et Robyn Wilson, et Trevor et Hanne James, le partenariat tripartite a acheté son premier vignoble en 1993 et a produit ses premiers vins en 1996. Une nouvelle cave a été construite en 1997, et 20 autres hectares de graviers ont été achetés en 2000. Réalisant qu'ils avaient trouvé de l'or avec leur fusion unique de terroir, de connaissances œnologiques et de techniques agricoles, le trio d'investisseurs souhaitait porter d'excellents vins à un autre niveau, mais les contraintes financières ont maintenu la croissance. plutôt qu'explosif. L'intérêt des banques ne pouvait pas tomber à un meilleur moment pour Trinity.
                    </div>

                    <div class="howto-title2">... Ou pas</div>
                    <div class="howto-text">
                        Cependant, quand les choses sont trop belles pour être vraies, elles le sont généralement, et Banks a été condamné à quatre
                        ans de prison pour escroquerie en 2017. Ce fut évidemment un coup dur pour le vignoble et
                        mettre les plans d'expansion en attente. La doublure argentée de ce nuage était que Trinity était à nouveau
                        jeté sous les projecteurs. L'intérêt ultérieur après le procès dans la cave de Hawke's Bay
                        s'est avéré fortuit pour Trinity et leurs vins exceptionnels et constants. En particulier, l'Hommage
                        La syrah est une vraie vedette - l'un des meilleurs rouges de Nouvelle-Zélande. Les prix sont restés stables autour de
                        75 euros la bouteille, mais avec Banks derrière les barreaux, seul le temps nous dira si Trinity aurait pu mordre
                        plus qu'ils ne peuvent mâcher.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Trinity Hill</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Considered by some as a new wine on the block, New Zealand actually has a deep-rooted history in
                        winemaking. While New Zealand wine traces its history to the 19th century, the modern wine
                        industry in New Zealand began in the mid-20th century and expanded rapidly in the early 21st
                        century, averaging a massive 17% per annum in the first two decades. This alone is good news for
                        wine investors the world over, but the impressive potential (not to mention taste) of Trinity
                        Hill wines stands out.
                    </div>

                    <div class="howto-title2">A billionaire decision ...</div>
                    <div class="howto-text">
                        Even more impressive was Charles Banks’ (of Screaming Eagle fame) 2014 decision to invest in
                        Trinity. Banks put up cash for 70% of Trinity’s holdings, signifying a supposedly long growth
                        for the Gimblett Gravels producer, and good news for New Zealand’s wine industry. With American
                        billionaires such as Banks’ investing heavily, surely others would follow?
                        <br><br>
                        Trinity hill burst arrived on the new world winemaking scene amid great promise. Founded by John, Robert and Robyn Wilson, and Trevor and Hanne James, the three-way partnership bought their first vineyard in 1993 and produced their first wines in 1996. A new winery was built in 1997, and a further 20 hectares of the gravels were purchased in 2000. Realising they had struck gold with their unique fusion of terroir, oenological knowledge and farming techniques, the trio of investors were keen to take excellent wines to another level but financial constraints kept growth steady rather than explosive. Banks’ interest could not have at a better time for Trinity.
                    </div>

                    <div class="howto-title2">... Or not</div>
                    <div class="howto-text">
                        However, when things are too good to be true, they usually are, and Banks’ was sentenced to four
                        years imprisonment for fraud in 2017. This obviously came as a huge blow for the vineyard and
                        put the expansion plans on hold. The silver lining to this cloud was that Trinity was once again
                        thrown into the spotlight. The subsequent interest after the trial in the Hawke’s Bay winery
                        proved fortuitous for Trinity and their consistent outstanding wines. In particular, the Homage
                        Syrah is a real stand-out – one of New Zealand’s top reds. Prices have remained stable at around
                        €75 euros a bottle, but with Banks behind bars, only time will tell if Trinity might have bitten
                        off more than they can chew.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrinityHill",
    data() {
        return {
            select: {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'},
            items: [
                {report: 'Ata Rangi', src: '/wine-guide/new-zealand/ata-rangi'},
                {report: 'Bell Hill Vineyards', src: '/wine-guide/new-zealand/bell-hill-vineyards'},
                {report: 'Craggy Range', src: '/wine-guide/new-zealand/craggy-range'},
                {report: 'Dog Point Vineyards', src: '/wine-guide/new-zealand/dog-point-vineyards'},
                {report: 'Millton Vineyards and Winery', src: '/wine-guide/new-zealand/millton-vineyards-and-winery'},
                {report: 'Pyramid Valley Vineyards', src: '/wine-guide/new-zealand/pyramid-valley-vineyards'},
                {report: 'Rippon Vineyards', src: '/wine-guide/new-zealand/rippon-vineyards'},
                {report: 'Trinity Hill', src: '/wine-guide/new-zealand/trinity-hill'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Trinity Hill | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the finest wines from Trinity Hill, a renowned New Zealand wine producer known for their expertly crafted red and white wines from the Hawke\'s Bay region. Savor the unique terroir and flavors of each bottle, carefully made to embody the essence of New Zealand\'s finest vineyards.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
